export default {
    search : {
        count: 5
    }
}


// WEBPACK FOOTER //
// ./src/utils/defaullts.js